import React from 'react';
import { string, shape, arrayOf, func, bool } from 'prop-types';
import MultiCheckboxFilter from '../multi-checkbox-filter/';

export default function TagFilter({ filter, selectedItems, isFocused, toggleFocus, toggleFilters, resetFilterGroup }) {
    return (
        <div className="tag-filter-wrapper">
            <div className="tag-filter-m">
                {/* Using MultiCheckboxFilter component for mobile */}
                <MultiCheckboxFilter
                    filter={filter}
                    selectedItems={selectedItems}
                    toggleFilters={toggleFilters}
                    classModifier="filter-item"
                    isFocused={isFocused}
                    toggleFocus={toggleFocus}
                />
            </div>
            <div className="tag-filter-dt">
                {/* Button tag styles for tablet and up */}
                <ul>
                    <li className={`tag-filter-item ${selectedItems.length === 0 ? 'active' : ''}`}>
                        <button onClick={() => resetFilterGroup(filter.code)}>
                            <small>All {filter.label}</small>
                        </button>
                    </li>
                    {filter.values.map(value => (
                        <li
                            key={value}
                            className={`tag-filter-item ${selectedItems.includes(value) ? 'active' : ''}`}
                        >
                            <button onClick={e => toggleFilters(e, filter, value)}>
                                <small dangerouslySetInnerHTML={{ __html: value }} />
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

TagFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string).isRequired
    }).isRequired,
    selectedItems: arrayOf(string).isRequired,
    toggleFilters: func.isRequired,
    resetFilterGroup: func.isRequired,
    toggleFocus: func.isRequired,
    isFocused: bool
    /* eslint-enable react/no-typos */
};

TagFilter.defaultProps = { isFocused: false };
